import api from './axios';
import { AdminBillingOverviewResponse, BillingHistoryResponse, BillingPaymentHistoryResponse, BillingPlan, BillingPlansResponse, ClaimSubscriptionResponse, EntitlementResponse, DowngradeSubscriptionRequest, UpgradeSubscriptionRequest } from './types';

const billingApi = {
    claimSubscription: async (): Promise<ClaimSubscriptionResponse> => {
        const response = await api.post('/billing/stripe/claim');
        return response.data;
    },

    getEntitlement: async (): Promise<EntitlementResponse> => {
        const response = await api.get('/entitlement');
        return response.data;
    },

    getPlans: async (): Promise<BillingPlansResponse> => {
        const response = await api.get('/billing/plans');
        return response.data;
    },

    getHistory: async (): Promise<BillingHistoryResponse> => {
        const response = await api.get('/billing/history');
        return response.data;
    },

    getPaymentHistory: async (): Promise<BillingPaymentHistoryResponse> => {
        const response = await api.get('/billing/payment-history');
        return response.data;
    },

    createPortalSession: async (): Promise<{ status: string; data: { url: string } }> => {
        const response = await api.post('/billing/portal-session');
        return response.data;
    },

    getAdminWorkspacePlans: async (workspaceId: string, includeInactive = true): Promise<BillingPlansResponse> => {
        const response = await api.get(`/billing/admin/workspaces/${workspaceId}/plans`, {
            params: { include_inactive: includeInactive },
        });
        return response.data;
    },

    getAdminOverview: async (): Promise<AdminBillingOverviewResponse> => {
        const response = await api.get('/billing/admin/overview');
        return response.data;
    },

    getAdminPlanTemplates: async (): Promise<BillingPlansResponse> => {
        const response = await api.get('/billing/admin/plan-templates');
        return response.data;
    },

    createAdminWorkspacePlan: async (workspaceId: string, data: Partial<BillingPlan>): Promise<{ status: string; data: BillingPlan }> => {
        const response = await api.post(`/billing/admin/workspaces/${workspaceId}/plans`, data);
        return response.data;
    },

    updateAdminWorkspacePlan: async (workspaceId: string, planId: string, data: Partial<BillingPlan>): Promise<{ status: string; data: BillingPlan }> => {
        const response = await api.patch(`/billing/admin/workspaces/${workspaceId}/plans/${planId}`, data);
        return response.data;
    },

    deleteAdminWorkspacePlan: async (workspaceId: string, planId: string): Promise<{ status: string; data: { plan_id: string; is_active: boolean } }> => {
        const response = await api.delete(`/billing/admin/workspaces/${workspaceId}/plans/${planId}`);
        return response.data;
    },

    cancelSubscription: async (): Promise<any> => {
        const response = await api.post('/billing/cancel');
        return response.data;
    },

    downgradeSubscription: async (data: DowngradeSubscriptionRequest): Promise<any> => {
        const response = await api.post('/billing/downgrade', data);
        return response.data;
    },

    resumeSubscription: async (): Promise<any> => {
        const response = await api.post('/billing/resume');
        return response.data;
    },

    upgradeSubscription: async (data: UpgradeSubscriptionRequest): Promise<any> => {
        const response = await api.post('/billing/upgrade', data);
        return response.data;
    }
};

export default billingApi;
